// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2PPVa","notes":"Notes_notes__3rCs4","note":"Notes_note__pVnJ6","markdown":"Notes_markdown__34Q-a"};